<template>
  <v-main>
    <NetworkDialog ref="dialog" @reload="$refs.report.reload()" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Nova rede...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { WifiNetwork } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import NetworkDialog from './NetworkDialog.vue'

export default {
  pageTitle: 'Wifi ─ Redes',
  components: {
    GenericReport,
    NetworkDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Wifi ─ Redes',
        apiBase: '/wifi/networks',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativas',
            defVal: false
          }
        ]
      },
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.checkDownload()
        }
      ]
    }
  },
  methods: {
    async newRow() {
      let label = 'Digite o nome (não o SSID) da nova rede'
      let name = await this.$prompt({ label })
      if (name != null) {
        let row = await this.$loading(async () => {
          return WifiNetwork.save({ name })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    },

    async selectRow({ row /*, isMiddle */ }) {
      let res = await this.$refs.dialog.open(row.id)
      if (res === true) this.$refs.report.reload()
    },

    async confirmDelete() {
      let res = await this.$confirmDeactivate({
        strings: 'rede;a',
        len: this.selectedIds.length
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await WifiNetwork.delete(id)
          }
          this.selectedIds = []
          this.$snack('Desativada(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
